import * as React from "react";
const SvgUploadCancel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M16.29 14.961a.94.94 0 1 1-1.327 1.328l-4.96-4.962-4.962 4.96a.94.94 0 0 1-1.328-1.328L8.674 10l-4.96-4.961a.94.94 0 1 1 1.328-1.329l4.96 4.962 4.962-4.962a.94.94 0 1 1 1.328 1.328L11.33 9.999l4.96 4.962Z"
    />
  </svg>
);
export default SvgUploadCancel;
